// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/sar-phases-and-codewords.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/sar-phases-and-codewords/sar-phases-and-codewords.js';

mount([g0]);
